import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import styles from './index.module.css';
import Login from './pages/Login';
import Footer from './components/Footer';
import CreateAccount from './pages/CreateAccount';
import RestorePassword from './pages/RestorePassword';
import DeleteAccount from './pages/DeleteAccount/Index';
import googleTagManager from './services/googleTagManager';
import instana, { ievent } from './services/instana';
import {
  useConfig,
  configGetAnalyticsPaApiUrl,
  configGetAnalyticsPaApiKey,
} from './services/ConfigProvider';
import { registerAnaTransport } from './services/anaAnalytics';
import { Brand, Loading } from './components';

import './App.css';

function App() {
  const config = useConfig();

  if (config && config.REACT_APP_ENABLE_INSTANA === 'true') {
    instana();
  }

  const COUNTRY = (config && config.REACT_APP_COUNTRY) || 'BR';
  window.localStorage.setItem('country', COUNTRY);

  if (!config) {
    return <Loading visibled={true} />;
  }

  //GA
  googleTagManager();
  ievent('page', 'login-front');

  // Registered during render, not in an effect: the pages below fire their first
  // page_view/ab_test_event from a mount effect, and child effects run before the
  // parent's, so an effect here would land after those events and drop them. The
  // call only reassigns a module-level object, so extra renders are a no-op.
  registerAnaTransport(
    configGetAnalyticsPaApiUrl(config),
    configGetAnalyticsPaApiKey(config),
  );

  return (
    <div className={`${styles.loginEntrarFbDesktopBr01}`}>
      <BrowserRouter>
        <Header />
        <section className={styles.brandLogin}>
          <div className={styles.brandLoginContent}>
            <Brand />

            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/create" element={<CreateAccount />} />
              <Route
                path="/restore-password/:restoreKey"
                element={<RestorePassword />}
              />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="/*" element={<Login />} />
            </Routes>
          </div>
        </section>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
